import { BookmarksStorage, getBookmarkedArticlesSummary } from './bookmarks';
import { prkModalConfigs } from '../common/hashed-links-handlers';
import escapeHTML from '../utils/escapeHTML';
import { getUserArticleRating, saveUserArticleRating } from './rating';

const makeBookmarkHtml = ({ id, title, url, preview }) => {
    title = escapeHTML(title);

    return `
      <section class="blog-bookmarks-grid__item">
        <a
          href="${url}"
          title="${title}"
        >
          <img class="blog-bookmarks-grid__item-picture" alt="${title}" src="${preview}" />
          <span class="blog-bookmarks-grid__item-title">${title}</span>
        </a>
        <div class="blog-bookmarks-grid__item-bookmark">
            <button
                data-article-id="${id}"
                data-active="true"
                class="blog-bookmarks__button blog-bookmarks__button--minified js-add-to-bookmarks"
            >
              <svg class="blog-bookmarks__button-icon pi pi-bookmark"><use xlink:href="#bookmark"/></svg>
            </button>
        </div>
        <div class="blog-bookmarks-grid__item-controls">
          <a
            class="btn btn-xs btn-success"
            href="${url}"
            title="${title}"
          >
            Подробнее
          </a>
        </div>
      </section>
    `;
}

export const initAddToBookMarksLogic = () => {
    const storage = new BookmarksStorage();

    const onClickAddToBookmarksButton = (e) => {
        const articleId = e.currentTarget.getAttribute('data-article-id');

        if (!articleId) { return; }

        const isArticleFavoured = e.currentTarget?.dataset.active !== 'true';
        if (isArticleFavoured) {
            storage.addArticle(articleId);
        } else {
            storage.removeArticle(articleId);
        }

        [...document.querySelectorAll(`.js-add-to-bookmarks[data-article-id="${articleId}"]`)]
            .forEach((item) => {
                if (isArticleFavoured) {
                    item.setAttribute('data-active', 'true');
                } else {
                    item.removeAttribute('data-active');
                }
            });
    }

    prkModalConfigs['blog-bookmarks'] = {
        onOpen: async function() {
            const modal = document.getElementById('blog-bookmarks');
            if (!modal) {
                return;
            }

            if (!modal.classList.contains('loaded')) {
                modal.innerHTML += `
                  <span class="blog-bookmarks-modal__title">Мои закладки</span>
                  <div class="blog-bookmarks-grid">
                    <div class="blog-bookmarks-grid__container js-my-bookmarks-container"></div>
                    <div class="blog-bookmarks-grid__empty">
                      У вас нет ни одной статьи в закладках.
                      <button data-prk-modal-action="close" class="btn btn-xs btn-success">Закрыть</button>
                    </div>
                  </div>
                `;

                modal.classList.add('loaded');
            }

            const container = modal.querySelector('.js-my-bookmarks-container');

            showLoader($(container));

            const bookmarks = await getBookmarkedArticlesSummary(
                storage.getBookmarkedArticleIds()
            );

            container.innerHTML = bookmarks
                .map(makeBookmarkHtml)
                .join('');

            [...container.querySelectorAll('.js-add-to-bookmarks')]
                .forEach((item) => item.addEventListener('click', onClickAddToBookmarksButton));

            hideLoader($(container));
        }
    }

    const initAddToBookmarksButtonLogic = () => {
        const button = document.querySelector('.js-add-to-bookmarks');
        if (!button) { return; }

        const articleId = button.getAttribute('data-article-id');
        if (!articleId) { return; }

        if (storage.containsArticle(articleId)) {
            button.setAttribute('data-active', 'true');
        } else {
            button.removeAttribute('data-active');
        }

        button.addEventListener('click', onClickAddToBookmarksButton);
    }

    initAddToBookmarksButtonLogic();
}

export const initArticleRating = () => {
    const articleRatingContainer = document.querySelector('.article-rating');
    if (!articleRatingContainer) {
        return;
    }

    const articleId = Number(articleRatingContainer.getAttribute('data-article-id') ?? '');
    if (!Number.isFinite(articleId) || !Number.isInteger(articleId) || articleId < 1) {
        return;
    }

    const buttons = [...articleRatingContainer.querySelectorAll('.js-article-rating')];

    /**
     * @param {Event} e
     */
    const onPressRatingButton = (e) => {
        const item = e.currentTarget;
        const rating = Number(item.getAttribute('data-rating') ?? '');

        if (!Number.isFinite(rating) || !Number.isInteger(rating)) {
            return;
        }

        item.classList.add('article-rating__list-item-button--selected');
        buttons.forEach((button) => button.disabled = true);

        // Do not await for promise to resolve – not that important functionality
        saveUserArticleRating(articleId, rating)
            .catch(() => null);

        const title = articleRatingContainer.querySelector('.article-rating__title');
        if (title) {
            title.innerHTML = 'Спасибо за ваш отзыв!'
        }
    }

    try {
        const rating = getUserArticleRating(articleId);
        if (!rating) {
            buttons.forEach((item) => item.addEventListener('click', onPressRatingButton));
        } else {
            const title = articleRatingContainer.querySelector('.article-rating__title');
            if (title) {
                title.innerHTML = 'Спасибо за ваш отзыв!'
            }

            buttons.forEach((item) => {
                item.disabled = true;
                if (item.getAttribute('data-rating') == rating) {
                    item.classList.add('article-rating__list-item-button--selected');
                }
            });
        }

        articleRatingContainer.hidden = false;
    } catch (e) {
    }
}